import { useState, useEffect } from "react";
import { MainLayout } from "../components/Layout";
import OpeningHoursSettings from "../components/OpeningHoursSettings";
import { Button } from "../components/ui/button";
import { Save, Loader2, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function HorairesPage() {
  const [settings, setSettings] = useState({ opening_hours: {}, slot_minutes: 60, blocked_slots: [] });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${API_URL}/api/admin/shop-settings`, { headers: { Authorization: `Bearer ${token}` } });
        setSettings({
          opening_hours: res.data.opening_hours || {},
          slot_minutes: res.data.slot_minutes || 60,
          blocked_slots: res.data.blocked_slots || [],
        });
      } catch {
        toast.error("Erreur lors du chargement");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const onChange = (field, value) => { setSettings((prev) => ({ ...prev, [field]: value })); setSaved(false); };

  const save = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem("token");
      await axios.put(`${API_URL}/api/admin/shop-settings`, settings, { headers: { Authorization: `Bearer ${token}` } });
      setSaved(true);
      toast.success("Horaires et blocages enregistrés");
      setTimeout(() => setSaved(false), 3000);
    } catch {
      toast.error("Erreur lors de l'enregistrement");
    } finally {
      setSaving(false);
    }
  };

  return (
    <MainLayout>
      <div className="mx-auto max-w-4xl space-y-4 p-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-800">Horaires &amp; rendez-vous</h1>
          <p className="text-sm text-gray-500">Réglez vos horaires d'ouverture et bloquez des dates ou des créneaux directement sur le calendrier.</p>
        </div>
        {!loading && <OpeningHoursSettings settings={settings} onChange={onChange} />}
        <Button onClick={save} disabled={saving || loading} className={`w-full ${saved ? "bg-emerald-500 hover:bg-emerald-600" : "bg-primary hover:bg-primary/90"}`}>
          {saving ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : saved ? <CheckCircle2 className="mr-2 h-4 w-4" /> : <Save className="mr-2 h-4 w-4" />}
          {saving ? "Enregistrement..." : saved ? "Enregistré !" : "Enregistrer"}
        </Button>
      </div>
    </MainLayout>
  );
}
